'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@common/components';
import { Image } from '@/components/client';
import { ROUTES } from '@/constants';
import { useCustomRouter } from '@/hooks/useCustomRouter';
import { useAuthStore } from '@/stores/AuthStore';
import { useGlobalStore } from '@/stores/GlobalStore';

/**
 * ⑩ 회원가입 CTA + 공유 + 면책 + 출처.
 * - 메인 CTA: 비로그인 → 로그인 페이지, 로그인 → 맞춤정책 페이지.
 * - 공유: 전역 ShareDrawer (Kakao SDK / Web Share / 클립보드 폴백 통합).
 */
export const FinalCta = () => {
  const $ = _c(15);
  const router = useCustomRouter();
  const isLogin = useAuthStore(_temp);
  const setShareLink = useGlobalStore(_temp2);
  let t0;
  if ($[0] !== isLogin || $[1] !== router) {
    t0 = () => {
      if (isLogin === undefined) {
        return;
      }
      if (!isLogin) {
        router.push(ROUTES.LOGIN.withSearchParams({
          searchParams: {
            redirect: ROUTES.RECOMMEND_POLICY_LIST.pathname
          }
        }));
        return;
      }
      router.push(ROUTES.RECOMMEND_POLICY_LIST.pathname);
    };
    $[0] = isLogin;
    $[1] = router;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const handleCtaClick = t0;
  let t1;
  if ($[3] !== setShareLink) {
    t1 = () => {
      if (typeof window === "undefined") {
        return;
      }
      setShareLink(window.location.href);
    };
    $[3] = setShareLink;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const handleShare = t1;
  let t2;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Image src="https://www.welfarehello.com/assets/pngs/silver-coin.png" alt={"\uB85C\uACE0 \uC2E4\uBC84 \uCF54\uC778 \uC774\uBBF8\uC9C0"} className="size-120" width={120} height={120} />;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <p className="text-Gray-500 typo-body4">회원가입하고</p>;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="flex flex-col items-center gap-2 text-center">{t3}<p className="text-Gray-900 typo-body3"><strong className="font-700">내게 딱 맞는 정책</strong> 확인하기</p></div>;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== handleCtaClick) {
    t5 = <Button theme="primary-fill" dimensions="H48" className="w-full" onClick={handleCtaClick}>내 맞춤정책 확인하기 →</Button>;
    $[8] = handleCtaClick;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== handleShare) {
    t6 = <Button theme="sub-line" dimensions="H48" className="w-full" onClick={handleShare}>공유하기</Button>;
    $[10] = handleShare;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t5 || $[13] !== t6) {
    t7 = <section className="flex flex-col gap-16 mobile-tablet:px-16"><div className="flex flex-col items-center gap-16 py-24">{t2}{t4}<div className="flex w-full flex-col gap-12">{t5}{t6}</div></div></section>;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
};
function _temp(state) {
  return state.isLogin;
}
function _temp2(state_0) {
  return state_0.setShareLink;
}